module.exports = "/images/ny-street-9.jpg";